import LinkIcon from "@mui/icons-material/Link";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useContext } from "react";
import { SnackbarContext } from "components/context/SnackbarProvider";

export const CopyToClipboard = ({ text, children, ...props }) => {
  const { displayMessage, displayError } = useContext(SnackbarContext);

  const copyToClipboard = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(
        () => displayMessage("'" + text + "' is in your clipboard."),
        () => displayError("[ERROR] Copying to the clipboard failed!"),
      );
    } else {
      displayError(
        "[ERROR] Copying to the clipboard failed! (no clipboard api in navigator)",
      );
    }
  };
  const innerChildren = children ? (
    <Box onClick={copyToClipboard} sx={{ cursor: "pointer" }}>
      {children}
    </Box>
  ) : (
    <IconButton onClick={copyToClipboard} {...props}>
      <LinkIcon sx={{ transform: "rotate(-45deg)", scale: "0.8" }} />
    </IconButton>
  );

  return <Tooltip title="copy to clipboard">{innerChildren}</Tooltip>;
};
